document.addEventListener('DOMContentLoaded', function() {
    const mediaQuery = window.matchMedia('(max-width: 750px)')
    const fixedCartID = document.getElementById('fixed--cart')
    const cartTrigger = document.querySelector('.trigger__fixed--cart')

    if (mediaQuery.matches && fixedCartID && cartTrigger) {
        let lastScrollPosition = window.pageYOffset
        let isFixed = false
        let scrollingTimeout

        function showFixedCart() {
            if (!isFixed) {
                fixedCartID.classList.add('fixed-atc', 'enabled', 'slide-up')
                isFixed = true
            }
        }

        function hideFixedCart() {
            if (isFixed) {
                fixedCartID.classList.remove('fixed-atc', 'enabled', 'slide-up')
                isFixed = false
            }
        }

        function handleScroll() {
            const currentScrollPosition = window.pageYOffset
            const triggerRect = cartTrigger.getBoundingClientRect()
            const viewportHeight = window.innerHeight
            const scrollingDown = currentScrollPosition > lastScrollPosition

            // Clear any existing timeout
            if (scrollingTimeout) {
                clearTimeout(scrollingTimeout)
            }

            // Show cart when:
            // 1. Scrolling down
            // 2. Trigger element is out of viewport
            // 3. Not at the bottom of the page
            if (scrollingDown && 
                triggerRect.bottom < 0 && 
                currentScrollPosition < (document.documentElement.scrollHeight - viewportHeight)) {
                showFixedCart()
            }
            // Hide cart when:
            // 1. Scrolling up
            // 2. Near the trigger element
            // 3. At the top of the page
            else if (!scrollingDown && 
                    (triggerRect.top > -100 || currentScrollPosition < 100)) {
                hideFixedCart()
            }

            lastScrollPosition = currentScrollPosition

            // Set a timeout to handle scroll end
            scrollingTimeout = setTimeout(() => {
                const finalTriggerRect = cartTrigger.getBoundingClientRect()
                if (finalTriggerRect.top > -100) {
                    hideFixedCart()
                }
            }, 150)
        }

        // Add scroll event listener with passive flag for better performance
        window.addEventListener('scroll', handleScroll, { passive: true })

        // Initial check
        handleScroll()

        // Handle resize events
        window.addEventListener('resize', handleScroll, { passive: true })

        // Handle page visibility changes
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                handleScroll()
            }
        })
    }
})